import "babel-polyfill"

import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import '@/common/reset.css';
import '@/common/pc.css';
import '@/common/m.css';
import store from './store';

import 'default-passive-events'
import axios from 'axios'
import {
  getQueryString
} from '@/libs/util.js';
Vue.prototype.axios = axios;
import {
  setStore,
  getStore,
  removeStore
} from '@/libs/storage';
import {
  getRequest,
  postRequest,
  $http
} from '@/libs/http/$http.js';

// import 'amfe-flexible'

// const createVConsole = () => {
//   const wind = window
//   const script = document.createElement('script')
//   script.src = 'https://cdn.bootcdn.net/ajax/libs/vConsole/3.8.1/vconsole.min.js'
//   script.async = true
//   script.onload = () => {
//     const VConsole = new wind.VConsole()
//     console.log('VConsole loaded', VConsole)
//   }
//   document.body.appendChild(script)
// }
// createVConsole()

import '@/libs/flexible'

// import VueCookies from 'vue-cookies'
// Vue.use(VueCookies)

console.log()

Vue.prototype.baseURL = window.$config.thost

import 'vant/lib/index.css';
import {
  Toast
} from 'vant';
Vue.use(Toast);
Vue.prototype.$toast = Toast;

/*element*/
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../../theme/index.css'
Vue.use(ElementUI);
import {
  Loading,
  // Message,
} from 'element-ui';

// 挂载全局使用的方法
Vue.prototype.$http = $http;
Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;

Vue.prototype.setStore = setStore;
Vue.prototype.getStore = getStore;
Vue.prototype.removeStore = removeStore;

Vue.prototype.$loading = Loading.service;
Vue.config.productionTip = false;

// main.js


let init = () => {
  new Vue({
    store,
    router,
    /*   i18n,*/
    render: h => h(App),
  }).$mount('#app')
}

init();